// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"469":"f435e68a","840":"d777a351"}[chunkId] + ".chunk.js";
};